<div class="app-bg min-h-screen">
  <app-sidebar>
    <div class="route-animation-host" [@routeAnimations]="prepareRoute(routerOutlet)">
      <router-outlet #routerOutlet="outlet"></router-outlet>
    </div>
  </app-sidebar>
</div>
<lib-alert-wrapper></lib-alert-wrapper>
